import React, { useEffect, useRef, memo, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const TradingViewMarketData = memo(({ height = '500px' }) => {
  const container = useRef();
  const [hasLoaded, setHasLoaded] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView && !hasLoaded && container.current) {
      setHasLoaded(true);
      
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js';
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
        {
          "width": "100%",
          "height": "100%",
          "symbolsGroups": [
            {
              "name": "Indices",
              "originalName": "Indices",
              "symbols": [
                {"name": "FOREXCOM:SPXUSD", "displayName": "S&P 500"},
                {"name": "FOREXCOM:NSXUSD", "displayName": "Nasdaq 100"},
                {"name": "FOREXCOM:DJI", "displayName": "Dow Jones"}
              ]
            },
            {
              "name": "Crypto",
              "originalName": "Crypto",
              "symbols": [
                {"name": "BINANCE:BTCUSDT", "displayName": "Bitcoin"},
                {"name": "BINANCE:ETHUSDT", "displayName": "Ethereum"},
                {"name": "BINANCE:SOLUSDT", "displayName": "Solana"}
              ]
            },
            {
              "name": "Commodities",
              "originalName": "Commodities",
              "symbols": [
                {"name": "TVC:GOLD", "displayName": "Gold"},
                {"name": "TVC:SILVER", "displayName": "Silver"},
                {"name": "TVC:USOIL", "displayName": "Crude Oil WTI"}
              ]
            }
          ],
          "showSymbolLogo": true,
          "isTransparent": false,
          "colorTheme": "light",
          "locale": "en"
        }`;
      
      container.current.appendChild(script);
    }
  }, [inView, hasLoaded]);

  return (
    <div ref={ref} className="tradingview-widget-container" style={{ height, width: '100%' }}>
      <div ref={container} style={{ height: '100%', width: '100%' }}>
        {!hasLoaded && <div className="text-center py-8 text-gray-500">Loading market data...</div>}
      </div>
    </div>
  );
});

TradingViewMarketData.displayName = 'TradingViewMarketData';

export default TradingViewMarketData;
